// API Base URL yapilandirmasi
//
// WEB (tarayici): backend, frontend'i kendisi sunar; bu yuzden API HER ZAMAN
// AYNI ORIGIN'dedir ve gorece (relative) yol kullaniriz. Coklu kiracili
// mimaride kiraci alt alan adindan cozumlendigi icin (musteri.ornek.com)
// mutlak bir URL'e DUSMEK YASAK: mutlak URL, isteyi baska bir host'a
// gonderip alt alan adi bilgisini — dolayisiyla kiraci baglamini — kaybettirir.
//
// NATIVE (APK/iOS): sayfa file:// veya capacitor:// uzerinden acildigi icin
// "ayni origin" diye bir sey yoktur; mutlak URL ZORUNLUDUR ve yalnizca
// REACT_APP_API_BASE_URL'den gelir. Sabit bir adres GOMULMEZ — eski gomulu
// Railway adresi olu bir servise isaret ediyordu ve kullaniciya "sunucu
// kapali" gibi anlasilmaz hatalar uretiyordu. Adres yoksa acikca "sunucu
// adresi yapilandirilmamis" durumuna dusuyoruz (bkz. NATIVE_API_YAPILANDIRILMAMIS).
const trimUrl = (u) => (u || '').trim().replace(/\/$/, '');

/** Mutlak (sema iceren) bir URL mi? Native'de gorece adres ise yaramaz. */
const mutlakMi = (u) => /^https?:\/\//i.test(u || '');

export const isNativeShell = () => {
  if (typeof window === 'undefined') return false;
  // Capacitor/Cordova yerel kabuk
  const C = window.Capacitor;
  if (C) {
    try {
      if (typeof C.isNativePlatform === 'function') return C.isNativePlatform();
      const p = C.getPlatform && C.getPlatform();
      return p === 'android' || p === 'ios';
    } catch (_) { /* yoksay */ }
  }
  // file:// uzerinden acilan paketlenmis uygulama
  return !!(window.location && window.location.protocol === 'file:');
};

// Native'de sunucu adresi eksik/gecersiz oldugunda true olur. UI bunu okuyup
// "Sunucu adresi yapilandirilmamis" ekrani gosterebilir; aksi halde kullanici
// yalnizca anlamsiz "Network Error" gorurdu.
export let NATIVE_API_YAPILANDIRILMAMIS = false;

// Ayni uyariyi her istekte tekrar basmamak icin (interceptor her cagriyi
// getApiBaseUrlDynamic'e sokuyor).
let uyariBasildi = false;

const uyar = (mesaj) => {
  if (uyariBasildi) return;
  uyariBasildi = true;
  console.error(`⚠️ ${mesaj}`);
};

const getApiBaseUrl = () => {
  const envApiUrl = trimUrl(process.env.REACT_APP_API_BASE_URL);

  // APK / native: mutlak URL zorunlu, kaynak SADECE env.
  if (isNativeShell()) {
    if (!envApiUrl) {
      NATIVE_API_YAPILANDIRILMAMIS = true;
      uyar(
        'Sunucu adresi yapilandirilmamis: REACT_APP_API_BASE_URL bos. ' +
        'APK derlemeden once client/.env.production.local dosyasina ' +
        'REACT_APP_API_BASE_URL=https://app.alan-adiniz.com yazip yeniden derleyin ' +
        '(bkz. client/.env.mobile.example).'
      );
      return '';
    }
    if (!mutlakMi(envApiUrl)) {
      // Gorece adres native'de file:// koku ile birlesir ve asla sunucuya ulasmaz.
      NATIVE_API_YAPILANDIRILMAMIS = true;
      uyar(
        `Sunucu adresi gecersiz: REACT_APP_API_BASE_URL mutlak olmali (https:// ile baslamali). Bulunan: "${envApiUrl}"`
      );
      return '';
    }
    NATIVE_API_YAPILANDIRILMAMIS = false;
    if (process.env.REACT_APP_DEBUG_API === 'true') {
      console.log('🚀 API URL (NATIVE):', envApiUrl);
    }
    return envApiUrl;
  }

  // WEB: her zaman ayni origin (relative). env'de bir adres olsa bile BILEREK
  // yok sayiyoruz — alt alan adi ile kiraci cozumlemesi ancak boyle calisir.
  NATIVE_API_YAPILANDIRILMAMIS = false;
  if (envApiUrl && process.env.REACT_APP_DEBUG_API === 'true') {
    console.warn(
      'ℹ️ REACT_APP_API_BASE_URL web build\'inde yok sayildi; ayni origin kullaniliyor.'
    );
  }
  if (process.env.REACT_APP_DEBUG_API === 'true') {
    console.log('🚀 API URL (WEB - same origin, relative /api)');
  }
  return '';
};

// Her cagrida yeniden hesapla (runtime'da dinamik)
export const getApiBaseUrlDynamic = () => getApiBaseUrl();

/**
 * Native'de sunucu adresi eksik mi?
 *
 * Fonksiyon olarak da veriyoruz: Capacitor kopruyu sayfa yuklendikten SONRA
 * enjekte edebildigi icin ilk hesaplama "web" diyebilir; bu cagri o anki
 * gercek durumu dondurur.
 */
export const nativeApiYapilandirilmamisMi = () => {
  getApiBaseUrl();
  return NATIVE_API_YAPILANDIRILMAMIS;
};

// Ilk yukleme icin varsayilan deger (sonra runtime'da guncellenir)
export let API_BASE_URL = getApiBaseUrl();

// Runtime'da guncelle (uygulama yuklendiginde)
if (typeof window !== 'undefined') {
  // DOMContentLoaded veya hemen guncelle
  const updateApiUrl = () => {
    const newUrl = getApiBaseUrl();
    if (newUrl !== API_BASE_URL) {
      if (process.env.REACT_APP_DEBUG_API === 'true') {
        console.log('🔄 API URL guncelleniyor:', API_BASE_URL, '->', newUrl);
      }
      API_BASE_URL = newUrl;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateApiUrl);
  } else {
    updateApiUrl();
  }

  // Window load'ta da kontrol et
  window.addEventListener('load', updateApiUrl);
}

// API endpoint helper
export const apiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const fullUrl = `${API_BASE_URL}${cleanEndpoint}`;
  if (process.env.REACT_APP_DEBUG_API === 'true') {
    console.log('🔗 API Endpoint:', fullUrl || cleanEndpoint);
  }
  return fullUrl || cleanEndpoint;
};

if (process.env.REACT_APP_DEBUG_API === 'true') {
  console.log('✅ API Base URL:', API_BASE_URL || '(relative)');
}
